export default "__VITE_ASSET__DFRCCpD3__"